var map = {
	"./4-track-glockenspiel_55.jpg": 54416,
	"./4-track-music-box_55.jpg": 58819,
	"./4-track-toy-piano_55.jpg": 40364,
	"./dxtraterrestrial-1_55.jpg": 64289,
	"./dxtraterrestrial-2_55.jpg": 90444,
	"./edb-orgel_55.jpg": 68428,
	"./elektrisk-salmesykkel_55.jpg": 55355,
	"./lo-fi-tape-piano_55.jpg": 91709,
	"./midnight-wurli_55.jpg": 6433,
	"./omni-84_55.jpg": 10307,
	"./strykebrett_55.jpg": 51390,
	"./stylopoly_55.jpg": 28198,
	"./subc_55.jpg": 7894,
	"./voltage-controlled-cassette-organ_55.jpg": 4141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56575;